"use client";

import { useEffect, useState } from "react";

/**
 * The reason the user is looking at a login screen they did not ask for.
 *
 * `AccessChangeListener` signs them out the moment an admin changes their
 * access, and leaves the sentence behind in `sessionStorage` because the sign
 * out is a full navigation and nothing else survives it. Read once, then
 * cleared: it explains this sign out, not the next one.
 *
 * Without it the user is simply thrown to a login page mid-task, which is
 * indistinguishable from the app crashing.
 */
export default function AccessChangeNotice() {
	const [notice, setNotice] = useState<string | null>(null);

	useEffect(() => {
		try {
			const stored = sessionStorage.getItem("access-change-notice");
			if (!stored) return;
			sessionStorage.removeItem("access-change-notice");
			setNotice(stored);
		} catch {
			// Private browsing. There is simply no notice to show.
		}
	}, []);

	if (!notice) return null;

	return (
		<div className="border-warning/40 bg-warning/10 mb-4 rounded-md border px-3 py-2.5">
			<p className="text-xs leading-[1.6]">{notice}</p>
		</div>
	);
}
